export default __webpack_public_path__ + "static/char-36-9c59fde47f9d6601f47a2c014a1dc6e4.webp";